export default {"src":"/_next/static/media/alert-circle.64fcd247.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};